// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1086":"7321c3fc","1893":"996943ca","3376":"7321c3fc"}[chunkId] + ".chunk.css";
};